module.exports = __webpack_public_path__ + "media/images/icon-home-on@3x-2996f410c90e5bcca61bac74caf8b491.png";